import IComponent from "components/commons/IComponent";
import "./DivTable.scoped.css";
import react, { useEffect } from "react";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";

class DivTable extends IComponent {
  tableRef = undefined;
  tmpDIVRef = undefined;
  constructor(props) {
    super(props);
    this.state = {
      hasScrollbar: false,
      actionWidth: 60,
      sortingColumn: undefined,
      sortingType: 0,
    };
    this.tableRef = react.createRef();
    this.tmpDIVRef = react.createRef();
  }
  componentDidMount() {
    this.checkScrollbar();
  }
  componentWillUnmount() {}
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.data !== this.props.data) {
      this.checkScrollbar();
    }
    if (
      this.props.actionColumn &&
      prevProps.actionColumn !== this.props.actionColumn
    ) {
      this.setState({
        actionWidth: Math.max(60, this.props.actionColumn.length * 40),
      });
    }
    if (
      this.props.LayerTitle &&
      this.props?.LayerTitle.includes("To be confirmed by LIC") &&
      this.tmpDIVRef &&
      this.tmpDIVRef.current
    ) {
      this.tmpDIVRef.current.innerHTML = "";
      this.tmpDIVRef.current.appendChild(
        this.props.data.find((i) => i.Name == "Report")["Value"]
      );
    }
  }
  checkScrollbar() {
    let { scrollHeight, clientHeight } = this.tableRef.current;
    this.setState({
      hasScrollbar: scrollHeight !== clientHeight,
    });
  }

  render() {
    let { sortingColumn, sortingType } = this.state;
    let { selectedRow } = this.props;
    selectedRow = selectedRow || [];
    let actionStyle = {
      width: `${this.state.actionWidth}px`,
    };
    let noheader = typeof this.props.hideHeader !== "undefined";
    let data = this.props.data || [];
    if (typeof sortingColumn !== "undefined") {
      data = [...data];
      data.sort((a, b) => {
        if (sortingType === 2) {
          let tmpB = b;
          b = a;
          a = tmpB;
        }
        let valA = a[sortingColumn];
        let valB = b[sortingColumn];
        let result = undefined;
        if (typeof valA === "number") result = valA - valB;
        else if (typeof valA === "string") result = valA.localeCompare(valB);
        return result;
      });
    }
    return (
      <div className="DivTableContainer">
        {!noheader && (
          <div className="ListRow TableCaption">
            {this.props.columnDef.map((i, j) => (
              <div
                key={j}
                style={i.width && { width: i.width, flexShrink: 0 }}
                onClick={() => {
                  sortingType = (sortingType + 1) % 3;
                  sortingColumn = sortingType === 0 ? undefined : i.value;
                  this.setState({
                    sortingType,
                    sortingColumn,
                  });
                }}
              >
                {i.name}
                {sortingColumn === i.value && (
                  <span className="SortingIcon">
                    {sortingType === 1 ? (
                      <ArrowUpwardIcon />
                    ) : (
                      <ArrowDownwardIcon />
                    )}
                  </span>
                )}
              </div>
            ))}
            {this.props.actionColumn && (
              <div className="actionColumn" style={actionStyle}>
                Action
              </div>
            )}
            {this.state.hasScrollbar && (
              <div className="scrollbarPH">&nbsp;</div>
            )}
          </div>
        )}

        <div
          className={`ContentArea${noheader ? " NoHeader" : ""}`}
          ref={this.tableRef}
        >
          {this.props.noDataText ? (
            <div className="NoDataText">{this.props.noDataText}</div>
          ) : (
            undefined
          )}
          {data.map((i, j) => (
            <div className="ListRow" key={i + "-" + j}>
              {this.props.columnDef.map((k, l) => (
                <div
                  key={k.value + "-" + l}
                  style={k.width && { width: k.width, flexShrink: 0 }}
                  onClick={() =>
                    this.props.onRowClick && this.props.onRowClick(i, j)
                  }
                  onMouseOver={() =>
                    this.props.onRowMouseOver && this.props.onRowMouseOver(i, j)
                  }
                  onMouseOut={() =>
                    this.props.onRowMouseOut && this.props.onRowMouseOut(i, j)
                  }
                  className={selectedRow.includes(j) ? "selected" : ""}
                >
                  {this.props?.LayerTitle?.includes(
                    "To be confirmed by LIC"
                  ) ? (
                    typeof i[k.value] !== "undefined" ? (
                      k.format ? (
                        k.format(i[k.value], i)
                      ) : typeof i[k.value] == "object" ? (
                        <div ref={this.tmpDIVRef} />
                      ) : (
                        i[k.value]
                      )
                    ) : k.nullValue ? (
                      k.nullValue
                    ) : (
                      ""
                    )
                  ) : (
                    <>
                      {typeof i[k.value] !== "undefined"
                        ? k.format
                          ? k.format(i[k.value], i)
                          : i[k.value]
                        : k.nullValue
                        ? k.nullValue
                        : ""}
                    </>
                  )}
                </div>
              ))}
              {this.props.actionColumn && (
                <div
                  style={actionStyle}
                  className={selectedRow.includes(j) ? "selected" : ""}
                >
                  <div className="actionColumn EqualWidthChildren">
                    {this.props.actionColumn.map((item, idx) => (
                      <span
                        key={`SPAN-${idx}`}
                        className={item.className}
                        onClick={() => item.onClick(i, j)}
                      />
                    ))}{" "}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default DivTable;
